const SHOWCASE_FR = {
  title: 'Showcase',
  subtitle:
    'Cette page vous permet de comparer les caractéristiques de chacun des profils présentés.',
  mobileView:
    'Nous avons optimisé cette expérience sur Desktop, pour rendre plus exploitables les données et évaluations sur les candidats.',
  lastViewUpdate:
    'Consultation enregistrée le {{ date, datetime(format: dd/MM/yyyy) }} à {{ date, datetime(format: HH:mm) }}',
  yes: 'Oui',
  no: 'Non',
  bubbleText:
    'Cette page compare les caractéristiques des candidats qui vous ont été présentés. Un outil pour vous aider à choisir les bons profils.',
  emptyCandidateList:
    'Ici, vous pourrez <strong>comparer</strong> les principales caractéristiques des <strong>candidats</strong> que nous vous avons présentés.',
  tableRows: {
    photo: 'Photo',
    age: 'Âge',
    seniority: 'Expérience',
    location: 'Résidence',
    must_have: 'Must have',
    nice_to_have: 'Nice to have',
    current_global_compensation: 'Package de rémunération actuel',
    desired_global_compensation: 'Package de rémunération souhaité',
    non_compete_agreement: 'Clauses de non-concurrence',
    notice_period: 'Période de préavis',
    company: 'Entreprise',
    other_selections: 'Autres<1></1>processus<1></1>de sélection',
    motivation: "A l'écoute",
    summary: 'Synthèse',
  },
  filters: {
    restoreView: 'Restaurer la consultation',
    interestedBut: 'Voir <1>interested but</1>',
    out: 'Voir <1>candidats out</1>',
  },
  benefitsCategories: {
    car: 'Voiture de fonction',
    food: "Titres-restaurant ou cantine d'entreprise",
    training: 'Formation',
    welfare: 'Avantages sociaux',
    insurance: 'Mutuelle',
    devices: 'Matériel',
    remote_working: 'Télétravail ou horaires flexibles',
  },
  company: {
    freelance: 'Indépendant / Freelance',
  },
  concernsCategories: {
    brand: 'Marque',
    role: 'Rôle',
    compensation: 'Salaire',
    location: 'Localisation',
  },
  location: {
    locationAndDistance: '<strong>{{ location }}</strong>',
    locationAndDistance_withDistance:
      '<strong>{{ location }}</strong> ({{ distance }}km)',
  },
  summary: {
    readmore: 'Lire plus',
    hide: 'Masquer',
  },
  chip: {
    interestedBut: 'Interested but',
    out: 'Out',
  },
  motivationToChangeValues: {
    low: 'Low',
    high: 'High',
    medium: 'Medium',
  },
  drivingTime: {
    hours: '<b>{{ hours }}</b> h',
    minutes: '<b>{{ minutes }}</b> min',
  },
  otherSelections: {
    inProgress: '{{ count }} en cours',
    notSpecified: 'Autres en cours, non spécifiés',
  },
  currentGlobalCompensation: {
    payTransparencyDisclaimer:
      'Il est légalement interdit de demander des informations sur la rémunération actuelle ou passée depuis le 7 juillet 2026 (Directive (UE) 2023/970).<br/><br/>Concentrez-vous plutôt sur les prétentions salariales.',
  },
};

export default SHOWCASE_FR;
